import React from 'react';
import { connect } from "react-redux";
import createUsers from '../../../../API/Provider/CreateUser'
import { BsBackspaceFill } from 'react-icons/bs'
import { store } from 'react-notifications-component';
import Loader from '../../../../Global/loader'
import { withNamespaces } from 'react-i18next';
import OIBchecker from '../../../../Global/OIBchecker';
import { Form, Row, Col, Button } from 'react-bootstrap'

class CreateUsers extends React.Component {
    constructor(props) {
        super(props); 
        this.submitCreate = this.submitCreate.bind(this);
    }

    state={
        loading: false,

        label: "",
        description: "",
        tax_rate: 0,
        countries: [],
        country: null,
        oib: ""
    }

    componentDidMount = async () => {
        document.title = this.props.t("Users") + "-" + this.props.t("Create")

        await this.setState({
            loading: false            
        })
    }

    handleChange(e){
        if (e.target.id === "oib") {
            if(e.target.value.length < 12){
                this.setState({
                    [e.target.id]: e.target.value
                }) 
            }
        }
        else{
            this.setState({
                [e.target.id]: e.target.value
            })
        }
    }

    submitCreate = async (e) => {   
        this.setState({ loading: true })
        e.preventDefault()        

        if(OIBchecker(this.state.oib) ||this.state.oib === ""){
            let createPP = await createUsers(         
                this.state,
                this.props
            )

            if(createPP.data.status === 201){ 
                store.addNotification({
                    title: this.props.t('Success!'),
                    message: this.props.t("Creating was successful"),
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                    duration: 5000,
                    pauseOnHover: true
                    }
                });

                this.setState({ loading: false })
                this.props.goBack()
            }
            else{
                store.addNotification({
                    title: this.props.t('Error!'),
                    message: this.props.t(createPP.data.message),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                    duration: 5000,
                    onScreen: true
                    }
                })

                this.setState({ loading: false })
            }
        }
        else{
            store.addNotification({
                title: this.props.t('Error!'),
                message: this.props.t('Invalid OIB'),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })

            this.setState({ loading: false })
        }
        
    }

    handleCountryChange(e){  
        this.setState({
            country: e
        })                  
    }
   
    render(){  
        const { t } = this.props
        
        return (
            <div>
                {this.state.loading ?
                    <Loader />
                   
                :
                <Form className="form-container">
                    <Row>        
                        <Col sm={12} lg={6} xl={4}>                            
                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="username" column sm={2} md={4}>{t('Username')}</Form.Label>
                                <Col sm={10} md={8}>
                                   <Form.Control        
                                        id="username"                          
                                        type="text"
                                        value={this.state.username}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </Col>
                            </Form.Group>

                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="oib" column sm={2} md={4}>{t('OIB')}</Form.Label>
                                <Col sm={10} md={8}>
                                   <Form.Control        
                                        id="oib"                          
                                        type="text"
                                        value={this.state.oib}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </Col>
                            </Form.Group>

                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="password" column sm={2} md={4}>{t('Password')}</Form.Label>
                                <Col sm={10} md={8}>
                                    <Form.Control
                                        id="password"  
                                        type="text"
                                        value={this.state.password}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </Col>
                            </Form.Group>

                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="email" column sm={2} md={4}>{t('Email')}</Form.Label>
                                <Col sm={10} md={8}>
                                    <Form.Control
                                        id="email"  
                                        type="text"
                                        value={this.state.email}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </Col>
                            </Form.Group>

                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="first_name" column sm={2} md={4}>{t('First name')}</Form.Label>
                                <Col sm={10} md={8}>
                                    <Form.Control
                                        id="first_name"  
                                        type="text"
                                        value={this.state.first_name}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </Col>
                            </Form.Group>

                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="last_name" column sm={2} md={4}>{t('Last name')}</Form.Label>
                                <Col sm={10} md={8}>
                                    <Form.Control
                                        id="last_name"  
                                        type="text"
                                        value={this.state.last_name}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </Col>
                            </Form.Group>

                            <Col sm={12} className="p-0 text-center">
                                <Button                                      
                                    className="btnSpremi" 
                                    onClick={(e) => this.submitUpdate(e)}
                                >
                                    {t('Save')}
                                </Button>
                            </Col>                                           
                        </Col>
                    </Row>           
                    
                    <Row className='back-button-container'>
                        <Button 
                            variant='default'
                            onClick={() => this.props.goBack()}
                        >
                            <BsBackspaceFill size={30} /> <strong>{t('Back')}</strong>
                        </Button>
                    </Row>  
                </Form>
                }
            </div>

        )
    }
}
const mapStateToProps = state => {
    return {
        oneProvider: state.provider.oneProvider
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(CreateUsers));